import React, { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import HeadPage from "pages/StepPages/StepFour/HeadPage";
import sass from "./objects.module.sass";
import { Search } from "components-new";
import { Button } from "components/shared";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import DropMenu from "pages/StepPages/StepFour/One/Tables/TableNavigate/DropMenu";
import ModalPortal from "components-new/ModalPortal";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import Textarea from "components-new/Textarea";
import { useLocation } from "react-router-dom";
import { snackWrapper } from "../../../helpers";
import { useAppDispatch } from "../../../toolkit/hooks";
import { checkCompletingReferences } from "../../../toolkit/references/references.thunks";
import {directoryAPI} from "../../../libs/apiClient/Directory";
import {ObjectStatusResponseRELOAD} from "../../../libs/apiClient/data-contracts";
import {userAPI} from "../../../libs/apiClient/User";

const initial: ITypeObjects = {
	comment: "",
	name: "",
	sequenceNumber: "",
};

const Modal: React.FC<{
	rootFunc: Dispatch<SetStateAction<ITypeObjects[]>>;
	trigger: { active: boolean; data: ITypeObjects | null };
	cancelWindow: () => void;
}> = ({ trigger, cancelWindow, rootFunc }) => {
	const [newType, setNewType] = useState<ITypeObjects>(initial);
	const dispatch = useAppDispatch();
	useEffect(() => {
		setNewType(trigger.data || initial);
	}, [trigger.data]);

	useEffect(() => {
		return () => {
			setNewType(trigger.data || initial);
		};
		//eslint-disable-next-line
	}, [trigger.active]);

	const send = () => {
		if (!trigger.data) {
			// создание
			directoryAPI.objectStatusesCreateNewStatusCreate(newType).then((r) => {
				snackWrapper("success","Запись успешно создана");
				rootFunc((prevState) => [...prevState, r.data]);
				cancelWindow();
				dispatch(checkCompletingReferences());
			});
		} else {
			// редактирование
			const { id, ...rest } = newType;
			directoryAPI.objectStatusesEditCreate(id!, rest).then((r) => {
				snackWrapper("success","Запись успешно создана");
				rootFunc((prevState) => [...prevState].map((_) => (_.id === r.data.id ? { ...r.data } : _)));
				cancelWindow();
				dispatch(checkCompletingReferences());
			});
		}
	};

	const changeField = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setNewType((prevState) => ({ ...prevState, [name]: value }));
	};
	return trigger.active ? (
		<ModalPortal
			outSide={false}
			title={trigger.data ? "Редактировать статус объекта" : "Добавить статус объекта"}
			handleClose={cancelWindow}>
			<div className={sass.modal}>
				<Textarea
					name={"name"}
					value={newType.name}
					onChange={changeField}
					placeholder={"Введите текст"}
					label={"Значение"}
					maxLength={150}
					required
				/>
				<Textarea
					name={"comment"}
					value={newType.comment || ""}
					onChange={changeField}
					placeholder={"Введите текст"}
					label={"Комментарий"}
				/>
				<div className={sass.btns}>
					<Button onClick={cancelWindow} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button disabled={!newType.name} onClick={send}>
						Готово
					</Button>
				</div>
			</div>
		</ModalPortal>
	) : null;
};

interface ITypeObjects extends Omit<ObjectStatusResponseRELOAD,'id'>{
	id?: number;
}

const ObjectStatuses = () => {
	const [search, setSearch] = useState("");

	const [filter, setFilter] = useState<ITypeObjects[] | null>(null);

	useEffect(() => {
		if (search) {
			setFilter(
				data.filter(
					(obj) =>
						obj.name.toLowerCase().includes(search.toLowerCase()) ||
						obj.comment.toLowerCase().includes(search.toLowerCase()),
				),
			);
		} else if (search === "") {
			setFilter(null);
		}
		//eslint-disable-next-line
	}, [search]);

	const [data, setData] = useState<ITypeObjects[]>([]);

	useEffect(() => {
		directoryAPI.objectStatusesListList().then((r) => {
			setData(r.data);
		});
	}, []);
	const location = useLocation();
	const [modal, setModal] = useState<{ active: boolean; data: ITypeObjects | null }>({ active: false, data: null });
	const [target, setTarget] = useState<HTMLOrSVGElement | undefined>();
	// const toggleTarget = (e: React.MouseEvent<HTMLOrSVGElement>) => {
	// 	e.stopPropagation();
	// 	target ? setTarget(undefined) : setTarget(e.currentTarget);
	// };
	const removeItem = () => {
		console.log("remove");
		// $api.delete(`/directory/object/type/${id}`).then(() => {
		//     setData(prevState => [...prevState].filter(_ => _.id !== Number(id)))
		//     Snackbar({
		//         factor: 'light',
		//         type: 'success',
		//         delay: 3000,
		//         title: 'Запись удалена',
		//         position: 'top-center'
		//     })
		// }).catch(error => {
		//     if (error.response.status === 500) {
		//         Snackbar({
		//             factor: 'light',
		//             type: 'error',
		//             delay: 3000,
		//             title: 'Удаление невозможно, этот тип уже используется',
		//             position: 'top-center'
		//         })
		//     }
		// });
	};
	const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearch(e.target.value);
	};
	const outlineStyle = useCallback(
		(id: number) => {
			return location.state && location.state.outline && location.state.outline === id ? sass.outline : "";
		},
		[location],
	);
	useOutsideAlerter(target, () => setTarget(undefined));

	const [disabled, setDisabled] = useState(false);
	const needRule = useCallback(() => {
		if (disabled) snackWrapper("error", "Не достаточно прав");
	}, [disabled]);
	useEffect(() => {
		userAPI.permissionsCheckCreate(0, ["dictionary.object_status.edit"])
			.then((r) => setDisabled(!r.data.length));
	}, []);
	return (
		<div className={sass.wrapper}>
			<Modal
				rootFunc={setData}
				trigger={modal}
				cancelWindow={() => setModal((prevState) => ({ ...prevState, active: false }))}
			/>
			<DropMenu target={target} click={removeItem} />
			<HeadPage title={"Статусы объектов"}>
				<div className={sass.head}>
					<Search className={sass.search} searchValue={search} handleSearch={changeHandler} />
					<Button disabled={disabled} onClick={() => setModal({ active: true, data: null })}>
						Добавить значение
					</Button>
				</div>
			</HeadPage>
			<table>
				<thead>
					<tr>
						<th>Порядковый номер</th>
						<th>Значение</th>
						<th>Комментарий</th>
						{/* <th/> */}
					</tr>
				</thead>
			</table>
			<div data-comment-false={true} className={sass.scroll}>
				<table>
					<tbody>
						{filter
							? filter.map((_, index) => (
									<tr
										className={outlineStyle(_.id!)}
										onClick={() => (disabled ? needRule() : setModal({ active: true, data: _ }))}
										key={index}>
										<td>{index + 1}</td>
										<td>{_.name}</td>
										<td>{_.comment || <span dangerouslySetInnerHTML={{ __html: "&#8212;" }} />}</td>
										{/* <td><ActionMenuIcon data-id={_.id} onClick={toggleTarget}/></td> */}
									</tr>
							  ))
							: data.map((_, index) => (
									<tr
										className={outlineStyle(_.id!)}
										onClick={() => (disabled ? needRule() : setModal({ active: true, data: _ }))}
										key={index}>
										<td>{index + 1}</td>
										<td>{_.name}</td>
										<td>{_.comment || <span dangerouslySetInnerHTML={{ __html: "&#8212;" }} />}</td>
										{/* <td><ActionMenuIcon data-id={_.id} onClick={toggleTarget}/></td> */}
									</tr>
							  ))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default ObjectStatuses;
